import React from 'react';
import { DataTable, Code } from '@scale/scaleui-radix';
import { SHEET_NAME_DYNAMIC_COLUMN_NAME } from 'react-scale/corp/views/DataCompassCardsV2/action/ExportToGoogleSheetsCard/ExportToGoogleSheetCardComponent';

const ParametersTable = () => {
  // Only one required param: sheetName
  const data = [
    {
      columnName: SHEET_NAME_DYNAMIC_COLUMN_NAME,
      description:
        "*Required* in imported data. The sheet that the data will be written to. If the sheet doesn't exist it will create a new sheet. If the sheet does exist, the headers and data will be overwritten.",
    },
  ];

  const columnHelper = {
    accessor: (key: 'columnName' | 'description', config: any) => ({
      ...config,
      accessorKey: key,
    }),
  };

  const ColumnNameCell = ({ value }: { value: string }) => <Code>{value}</Code>;
  const DescriptionCell = ({ value }: { value: string }) => <>{value}</>;
  const renderColumnName = (info: any) => <ColumnNameCell value={info.getValue()} />;
  const renderDescription = (info: any) => <DescriptionCell value={info.getValue()} />;

  const columns = [
    columnHelper.accessor('columnName', {
      id: 'columnName',
      header: 'Column Name',
      cell: renderColumnName,
    }),
    columnHelper.accessor('description', {
      id: 'description',
      header: 'Description',
      cell: renderDescription,
    }),
  ];

  return (
    <DataTable.Root
      columns={columns}
      data={data}
      enableSorting={false}
      enableColumnFilters={false}
      initialState={{
        pagination: {
          pageIndex: 0,
          pageSize: 10,
        },
      }}
    >
      {({ table }: any) => (
        <DataTable.Table>
          <DataTable.Header>
            {table.getHeaderGroups().map((headerGroup: any) => (
              <DataTable.HeaderGroup key={headerGroup.id}>
                {headerGroup.headers.map((header: any) => (
                  <DataTable.ColumnHeaderCell key={header.id} header={header} />
                ))}
              </DataTable.HeaderGroup>
            ))}
          </DataTable.Header>
          <DataTable.Body>
            {table.getRowModel().rows.map((row: any) => (
              <DataTable.Row key={row.id} row={row}>
                {row.getVisibleCells().map((cell: any) => (
                  <DataTable.Cell key={cell.id} cell={cell} />
                ))}
              </DataTable.Row>
            ))}
          </DataTable.Body>
        </DataTable.Table>
      )}
    </DataTable.Root>
  );
};

export default ParametersTable;
